var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 36V25.5M24 25.5C25.012 25.5008 26.0199 25.3738 27 25.122M24 25.5C22.9881 25.5008 21.9801 25.3738 21 25.122M28.5 40.078C25.5266 40.6427 22.4735 40.6427 19.5 40.078M27 44.844C25.0055 45.0528 22.9946 45.0528 21 44.844M28.5 36V35.616C28.5 33.65 29.816 31.97 31.516 30.984C34.372 29.3301 36.6029 26.7805 37.8629 23.7301C39.1228 20.6798 39.3416 17.299 38.4854 14.1117C37.6291 10.9244 35.7455 8.10845 33.1266 6.10019C30.5076 4.09193 27.2994 3.00348 23.999 3.00348C20.6987 3.00348 17.4905 4.09193 14.8715 6.10019C12.2525 8.10845 10.369 10.9244 9.51269 14.1117C8.65641 17.299 8.87522 20.6798 10.1352 23.7301C11.3952 26.7805 13.626 29.3301 16.482 30.984C18.182 31.97 19.5 33.65 19.5 35.616V36",
    stroke: "#151A1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.ee78f8fd0e1517ca08a3e4c360c5f32f.svg";
export { ForwardRef as ReactComponent };